import React, { useEffect, useRef } from "react";
import Icon from "./icons";

// Artemis usage in every panel (API-3797, API-3800, WEB-7135): the header's usage button and the view
// it opens: this month's allowance as a percentage, when it resets, credits left, and Buy credits,
// which works at any time, not only at the limit. Shown only to users with an allowance.

export const CREDITS_PAGE = '/artemis/credits'

export const UsageButton = ({ state, open, onToggle }) => (
  <button type="button" className={`artemis-icon-button artemis-header-button artemis-usage-button ${state.limit ? 'artemis-usage-button-limit' : state.warn ? 'artemis-usage-button-warn' : ''} ${open ? 'artemis-header-button-on' : ''}`}
    title="Artemis usage" aria-label={`Artemis usage: ${state.percent}% used`} aria-haspopup="dialog" aria-expanded={open} onClick={onToggle}>
    <Icon name="chart" size={17} />
    <span className="artemis-usage-button-pct">{state.limit ? '100%' : `${state.percent}%`}</span>
  </button>
)

const UsageMenu = ({ state, detail, onClose }) => {
  const ref = useRef(null)
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose() }
    const onDown = e => { if (ref.current && !ref.current.contains(e.target) && !e.target.closest('.artemis-usage-button')) onClose() }
    document.addEventListener('keydown', onKey)
    document.addEventListener('mousedown', onDown)
    return () => { document.removeEventListener('keydown', onKey); document.removeEventListener('mousedown', onDown) }
  }, [onClose])

  return (
    <div className="artemis-voice-menu artemis-usage-menu" role="dialog" aria-label="Artemis usage" ref={ref}>
      <span className="artemis-eyebrow">Artemis this month</span>
      <div className="artemis-usage-menu-line">
        <span className="artemis-flex">
          {state.limit ? 'Allowance and credits used' : state.onCredits ? 'Allowance used · using your credits' : `${state.percent}% of your allowance used`}
        </span>
      </div>
      <span className={`artemis-usage-bar ${state.limit ? 'artemis-usage-bar-limit' : state.warn ? 'artemis-usage-bar-warn' : state.onCredits ? 'artemis-usage-bar-credits' : ''}`}
        role="meter" aria-label="Artemis used this month" aria-valuemin={0} aria-valuemax={100} aria-valuenow={state.percent}>
        <span style={{ width: `${state.percent}%` }} />
      </span>
      {state.resets && <span className="artemis-usage-reset">Resets {state.resets}</span>}
      <span className="artemis-usage-menu-credits">
        {state.creditsLeft ? <>Credits: <b>{state.creditsLeft}</b> left{state.creditsExpire ? `, expires ${state.creditsExpire}` : ''}</> : 'No credits yet'}
      </span>
      {detail && detail.Replies != null && <span className="artemis-usage-reset">{detail.Replies} {detail.Replies === 1 ? 'reply' : 'replies'} this month</span>}
      <span className="artemis-popover-note">Artemis uses your monthly allowance first, then your credits.</span>
      <a className="artemis-usage-buy artemis-usage-menu-buy" href={CREDITS_PAGE} target="_blank" rel="noopener noreferrer">Buy credits</a>
    </div>
  )
}

export default UsageMenu
